(() => {
  'use strict';
  const cfg = window.CSF || {};
  const root = (cfg.root || '/').replace(/\/?$/, '/');
  const money = cents => new Intl.NumberFormat('de-DE', {style:'currency', currency:cfg.currency || 'EUR'}).format((Number(cents) || 0) / 100);
  const esc = value => String(value == null ? '' : value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const q = (s, ctx=document) => ctx.querySelector(s);
  const qa = (s, ctx=document) => [...ctx.querySelectorAll(s)];
  const jsonFetch = async (path, options={}) => {
    const response = await fetch(root + path, {...options, headers: {'Accept':'application/json', ...(options.body ? {'Content-Type':'application/json'} : {}), ...(options.headers||{})}});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || cfg.strings?.error || 'Fehler');
    return data;
  };
  const header = q('[data-site-header]');
  const onScroll = () => {if (header && header.classList.contains('site-header--overlay')) header.classList.toggle('is-scrolled', window.scrollY > 100);};
  document.addEventListener('scroll', onScroll, {passive:true});onScroll();
  const mobileToggle = q('[data-toggle-mobile]');
  const mobileNav = q('[data-mobile-nav]');
  if(mobileToggle && mobileNav) mobileToggle.addEventListener('click', () => {
    const open = mobileNav.hidden;
    mobileNav.hidden = !open;
    mobileToggle.setAttribute('aria-expanded', String(open));
    mobileToggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
  });
  const searchBox = q('[data-header-search]');
  q('[data-search-toggle]')?.addEventListener('click', () => {if (!searchBox) return;searchBox.hidden = !searchBox.hidden;if (!searchBox.hidden) q('input[type="search"]',searchBox)?.focus();});
  q('[data-search-close]')?.addEventListener('click', () => {if (searchBox) searchBox.hidden = true;});
  qa('.nav-group').forEach(d => {
    document.addEventListener('click', e => {if (!d.contains(e.target)) d.open=false;});
  });
  const drawer = q('[data-cart-drawer]');
  const backdrop = q('[data-cart-backdrop]');
  let lastFocus = null;
  const renderCart = cart => {
    qa('[data-cart-counter]').forEach(el => {el.textContent = cart.item_count;});
    const items = q('[data-cart-items]');
    const total = q('[data-cart-total]');
    if(total) total.textContent = money(cart.total_price);
    if(!items) return;
    if(!cart.items.length) {items.innerHTML='<div class="empty-state"><p>Ihr Warenkorb ist leer.</p></div>';return;}
    items.innerHTML = cart.items.map((item,i) => {
      const pic = item.image ? `<img src="${esc(item.image)}" alt="${esc(item.product_title)}" loading="lazy">` : '<div class="drawer-placeholder"></div>';
      return `<article class="drawer-line">${pic}<div><h3><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3>${item.variant_title && item.variant_title!=='Default Title' ? `<p>${esc(item.variant_title)}</p>` : ''}<div class="drawer-line__bottom"><strong>${money(item.final_line_price)}</strong><div class="drawer-controls"><button type="button" data-line-change="${i+1}" data-delta="-1" aria-label="Menge verringern">−</button><span>${item.quantity}</span><button type="button" data-line-change="${i+1}" data-delta="1" aria-label="Menge erhöhen">+</button><button type="button" data-line-change="${i+1}" data-quantity="0" aria-label="Entfernen">×</button></div></div></div></article>`;
    }).join('');
    items.dataset.cartQuantities = JSON.stringify(cart.items.map(item=>item.quantity));
  };
  const openCart = async () => {
    if (!drawer || !backdrop) return;
    lastFocus = document.activeElement;
    backdrop.hidden = false;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.classList.add('is-locked');
    q('[data-close-cart]',drawer)?.focus();
    try { renderCart(await jsonFetch('cart.js')); } catch(error){showCartError(error.message);}
  };
  const closeCart = () => {
    if(!drawer||!backdrop) return;
    drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');backdrop.hidden = true;document.body.classList.remove('is-locked');lastFocus?.focus?.();
  };
  const showCartError = msg => {const el = q('[data-cart-error]');if(el){el.textContent=msg;el.hidden=false;}};
  qa('[data-open-cart]').forEach(b=>b.addEventListener('click',openCart));
  q('[data-close-cart]')?.addEventListener('click',closeCart);
  backdrop?.addEventListener('click',closeCart);
  document.addEventListener('keydown', e => {
    if(e.key==='Escape'){closeCart();if(searchBox) searchBox.hidden=true;if(mobileNav) mobileNav.hidden=true;mobileToggle?.setAttribute('aria-expanded','false');}
    if(e.key==='Tab' && drawer?.classList.contains('is-open')){
      const focusables=qa('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])',drawer).filter(el=>!el.disabled && el.getClientRects().length);
      if(!focusables.length) return;
      if(e.shiftKey && document.activeElement===focusables[0]){e.preventDefault();focusables.at(-1).focus();}
      else if(!e.shiftKey && document.activeElement===focusables.at(-1)){e.preventDefault();focusables[0].focus();}
    }
  });
  q('[data-cart-items]')?.addEventListener('click', async e => {
    const button=e.target.closest('[data-line-change]'); if(!button) return;
    const line=Number(button.dataset.lineChange);
    let quantity=Number(button.dataset.quantity);
    if(!Number.isFinite(quantity)){
      const quantities=JSON.parse(q('[data-cart-items]').dataset.cartQuantities || '[]');
      quantity=Math.max(0,Number(quantities[line-1]||0)+Number(button.dataset.delta||0));
    }
    button.disabled=true;
    try{const cart=await jsonFetch('cart/change.js',{method:'POST',body:JSON.stringify({line,quantity})});renderCart(cart);}catch(error){showCartError(error.message);}finally{button.disabled=false;}
  });
  const addToCart = async form => {
    const submit=q('[type="submit"][name="add"],button[type="submit"]',form);
    const error=q('[data-product-error]',form);
    if(error) error.hidden=true;
    if(submit) submit.disabled=true;
    try {
      const data=new FormData(form);
      const variantId=data.get('id'); const qty=Math.max(1,Number(data.get('quantity') || 1));
      if(!variantId) throw new Error('Bitte wählen Sie eine Ausführung.');
      await jsonFetch('cart/add.js',{method:'POST',body:JSON.stringify({id:Number(variantId),quantity:qty})});
      await openCart();
    } catch(err){if(error){error.textContent=err.message;error.hidden=false;} else showCartError(err.message);}
    finally{if(submit) submit.disabled=false;}
  };
  qa('form[data-ajax-add], form.product-form').forEach(form=>form.addEventListener('submit', e=>{e.preventDefault();addToCart(form);}));
  const ps=q('[data-product-section]');
  if(ps){
    const variants=JSON.parse(q('[data-variants-json]',ps)?.textContent || '[]');
    const select=q('[data-variant-select]',ps);
    const error=q('[data-product-error]',ps);
    const update = () => {
      const v=variants.find(x=>String(x.id)===String(select?.value));if(!v)return;
      q('[data-price]',ps).textContent=money(v.price);
      const compare=q('[data-compare]',ps);
      if(compare) compare.innerHTML=Number(v.compare_at_price)>Number(v.price) ? `<s>${money(v.compare_at_price)}</s>` : '';
      const stock=q('[data-stock]',ps);
      if(stock){
        const opt=select?.selectedOptions?.[0];const tracked=opt ? opt.dataset.stockTracked === 'true' : Boolean(v.inventory_management);const qty=Number(opt?.dataset.stockQuantity ?? v.inventory_quantity);
        if(!v.available) stock.innerHTML='<span class="stock-dot stock-dot--off"></span>Nicht verfügbar';
        else if(tracked && qty>0) stock.innerHTML=`<span class="stock-dot"></span>Auf Lager: ${qty}`;
        else if(tracked && (opt?.dataset.stockPolicy || v.inventory_policy)==='continue') stock.innerHTML='<span class="stock-dot stock-dot--muted"></span>Bestellbar – derzeit kein Lagerbestand';
        else stock.innerHTML='<span class="stock-dot"></span>Verfügbar';
      }
      const sku=q('[data-sku]',ps);const skuWrap=q('[data-sku-wrap]',ps);
      if(sku){sku.textContent=v.sku||'';if(skuWrap) skuWrap.hidden=!v.sku;}
      const submit=q('[data-add-button]',ps);
      if(submit){submit.disabled=!v.available;submit.textContent=v.available?'In den Warenkorb':'Nicht verfügbar';}
      if(error)error.hidden=true;
      const mediaId=select?.selectedOptions?.[0]?.dataset.mediaId || v.featured_media?.id;if(mediaId){const thumb=q(`[data-media-id="${mediaId}"]`,ps);thumb?.click();}
      const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url.pathname+url.search+url.hash);
    };
    if(select && select.tagName==='SELECT')select.addEventListener('change',update);
    qa('[data-qty-step]',ps).forEach(button=>button.addEventListener('click',()=>{
      const input=q('[data-quantity]',ps);if(input)input.value=String(Math.max(1,Math.floor(Number(input.value)||1)+Number(button.dataset.qtyStep)));
    }));
    qa('[data-thumb]',ps).forEach(button=>button.addEventListener('click',()=>{
      const url=q('[data-media-full]',button)?.dataset.mediaFull;
      const main=q('.product-main-image',ps);if(url && main){main.src=url;main.removeAttribute('srcset');}
      qa('[data-thumb]',ps).forEach(el=>{const active=el===button;el.classList.toggle('is-active',active);el.setAttribute('aria-pressed',String(active));});
    }));
  }
  qa('[data-auto-submit]').forEach(input => input.addEventListener('change',()=>input.form?.requestSubmit()));
})();
